import React from 'react';
import { Header } from '../components';
import * as ROUTES from '../constants/routes';
import logo from "../logo.png"
export function HeaderContainer({ children }) {
   return (
      <Header>
         <Header.Frame>
            <Header.Logo to={ROUTES.HOME} alt="XeroMDS" src={logo}/>
            <Header.ButtonLink to={ROUTES.SIGN_IN}>Go to Login Page</Header.ButtonLink>
         </Header.Frame>
         {children}
      </Header>
   )
}